import React from 'react';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

interface Props<T> {
  label: string;
  sortKey: keyof T;
  currentKey: keyof T;
  dir: 'asc' | 'desc';
  onSort: (key: keyof T) => void;
}

function SortableTh<T>({ label, sortKey, currentKey, dir, onSort }: Props<T>) {
  const isActive = sortKey === currentKey;
  return (
    <th
      onClick={() => onSort(sortKey)}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
    >
      {label}{' '}
      {isActive
        ? (dir === 'asc' ? FaSortUp({ size: 12 }) : FaSortDown({ size: 12 }))
        : FaSort({ size: 12, style: { opacity: 0.4 } })}
    </th>
  );
}

export default SortableTh;
